import { Button, Card, Col, Popconfirm, Row, Statistic } from "antd";
import { VFC } from "react";
import { useSelector } from "../../../../../../redux/store";
import { LoadingOverlay } from "../../../../../../components/LoadingOverlay";
import { usePrepareForNamesMutation } from "../../../../utils/usePrepareForNamesMutation";
import { QuestionButton } from "../../../QuestionButton";
import { activePlayerSelector } from "../../../../../../redux/selectors/activePlayerSelector";
import { GameMasterActionMenu } from "./GameMasterActionMenu";

export const ActivePlayerAnzeige: VFC<{ small: boolean }> = ({ small }) => {
  const game = useSelector((state) => state.game.game);
  const currentUser = useSelector((state) => state.auth.user);

  const activePlayer = useSelector(activePlayerSelector)!;
  const isGameMaster = game?.masterUserId === currentUser?.uid;
  const resetMutation = usePrepareForNamesMutation();

  const isLoading = resetMutation.isLoading;
  const isMe = currentUser!.uid === activePlayer.userId;
  return (
    <>
      {isLoading && <LoadingOverlay />}
      <Card
        size={"small"}
        title={small ? undefined : "Aktiver Spieler"}
        extra={small ? undefined : <QuestionButton />}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Statistic
              title="Aktiver Spieler"
              value={activePlayer.displayName}
            />
          </Col>
          <Col span={12}>
            <Statistic
              title="Muss erraten:"
              value={isMe ? " " : activePlayer.inventedName}
            />
          </Col>
          {isGameMaster && <GameMasterActionMenu />}
        </Row>
      </Card>

      {!small && isGameMaster && (
        <Card style={{ marginTop: 16 }}>
          <Popconfirm
            onConfirm={() => resetMutation.mutate()}
            title={"Willst du die Begriffe wirklich zurücksetzen?"}
          >
            <Button danger block type={"primary"}>
              Spiel neu starten
            </Button>
          </Popconfirm>
        </Card>
      )}
    </>
  );
};
